import { render, staticRenderFns } from "./ClientInvoices.vue?vue&type=template&id=385ee28e&scoped=true&"
import script from "./ClientInvoices.vue?vue&type=script&lang=js&"
export * from "./ClientInvoices.vue?vue&type=script&lang=js&"
import style0 from "./ClientInvoices.vue?vue&type=style&index=0&id=385ee28e&scoped=true&lang=css&"
import style1 from "./ClientInvoices.vue?vue&type=style&index=1&lang=css&"
import style2 from "../../../node_modules/handsontable/dist/handsontable.full.css?vue&type=style&index=2&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "385ee28e",
  null
  
)

export default component.exports